import { TippyProps } from "@tippyjs/react";

export let tippyProps: TippyProps = {
    interactive: true,
    arrow: true,
    delay: [250, 250],
    placement: 'bottom',
    theme: 'light-border',
    appendTo: () => document.body
};